
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from 'react';

// Utils
import bemify from 'utils/bemify';

// Components
import RegisterForm from 'components/register-form';

// Templates
import Authentication from 'templates/authentication';

// SVG Images
import Circle1 from 'assets/images/register/desktop/circle-1.svg';
import Circle1Mobile from 'assets/images/register/mobile/circle-1.svg';
import Circle2 from 'assets/images/register/desktop/circle-2.svg';
import Circle3 from 'assets/images/register/desktop/circle-3.svg';
import Circle4 from 'assets/images/register/desktop/circle-4.svg';
import CircleOrange from 'assets/images/register/desktop/circle-orange.svg';
import Illustration from 'assets/images/register/desktop/illustration.svg';

// Styles
import stylesModule from 'styles/pages/register.module.scss';


const styles = bemify(stylesModule);

const Register = () => {
  const leftContent = (
    <RegisterForm />
  );

  const leftContentIllustrations = (
    <Circle4 className={`${styles.register__circle4} d-none d-md-block`} />
  );

  const rightContent = (
    <>
      <div className="d-none d-md-block">
        <Circle1 className={styles.register__circle1} />
        <Circle2 className={styles.register__circle2} />
        <Circle3 className={styles.register__circle3} />
        <CircleOrange className={styles.register__circleOrange} />
        <Illustration className={styles.register__illustration} />
      </div>
      <div className="d-md-none">
        <Circle1Mobile />
        <Illustration className={styles.register__illustration} />
      </div>
    </>
  );

  return (
    <Authentication
      leftContent={leftContent}
      leftContentIllustrations={leftContentIllustrations}
      rightContent={rightContent}
    />
  );
};

export default Register;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/register',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              
            }))
          }
        }
    }
  